<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     账单详情
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-bill-detail mb-md">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>

    <el-alert v-if="bill.status === 0" type="warning" :closable="false">
      <template slot="title">
        <p>
          <span>该账单已支付金额 {{ bill.money_payed | currency }}，欠款金额</span>
          <span class="span font-lg middle text-danger">{{ bill.money_total - bill.money_payed | currency }}</span>
        </p>
      </template>
    </el-alert>

    <el-alert v-if="bill.status === 1" type="success" :closable="false">
      <template slot="title">
        <p>账单已结清</p>
      </template>
    </el-alert>

    <el-card v-loading="loading" class="mt-md" shadow="never">
      <div class="display-info">
        <el-row>
          <el-col :span="20">
            <span class="font-3x">{{ bill.period }}</span>
            <span v-if="bill.status === 0" class="span">
              <el-button type="text" @click="buildBill">刷新账单</el-button>
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span class="text-muted">账期开始：</span>
            <span class="span">{{ bill.starttime | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
          </el-col>
          <el-col :span="6">
            <span class="text-muted">账期结束：</span>
            <span class="span">{{ bill.endtime | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
          </el-col>
          <el-col :span="6">
            <span class="text-muted">还款截止：</span>
            <span class="span" :class="{ 'text-danger': bill.status === 0 }">{{ bill.deadline | parseTime('{y}/{m}/{d}') }}</span>
          </el-col>
          <el-col v-if="bill.payedtime" :span="6">
            <span class="text-muted">清款时间：</span>
            <span class="span">{{ bill.payedtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card v-loading="loading" class="mt-md" shadow="never">
      <el-table
        ref="listTable"
        class="padding-small"
        :data="orders"
        style="width: 100%">
        <el-table-column type="index" width="50" align="center" />
        <el-table-column label="订单号" min-width="120">
          <template slot-scope="scope">
            <el-link :underline="false" @click="$router.push('/expense/order/detail?orderid=' + scope.row.orderid)">{{ scope.row.order_sn }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="主题" min-width="280" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link :underline="false" @click="$router.push('/expense/order/detail?orderid=' + scope.row.orderid)">{{ scope.row.subject }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" min-width="140" align="center">
          <template slot-scope="scope">
            <span :class="{ 'text-danger': scope.row.pay_status !== 1 }">{{ payStatusObj[scope.row.pay_status] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物流状态" min-width="140" align="center">
          <template slot-scope="scope">
            <span :class="{ 'text-danger': scope.row.shipping_status !== 3 }">{{ shippingStatusObj[scope.row.shipping_status] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" min-width="100" align="right">
          <template slot-scope="scope">
            <span>{{ scope.row.order_amount_total | currency }}</span>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <span>金额总计：</span>
              <span class="font-2x text-warning">{{ bill.money_total | currency }}</span>
            </template>
          </f-table-footer>
        </template>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import FTableFooter from '@/components/FTableFooter'
import { getBillDetailApi, buildBillApi } from '@/api/expense/expenseBillApi'
export default {
  name: 'ExpenseBillDetail',
  components: {
    FTableFooter
  },
  data() {
    return {
      loading: false,
      billid: this.$route.query.billid,
      bill: {},
      orders: []
    }
  },
  computed: {
    payStatusObj() {
      return this.$store.getters.payStatusObj
    },
    shippingStatusObj() {
      return this.$store.getters.shippingStatusObj
    }
  },
  watch: {
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getBillDetailApi(this.billid).then(res => {
        this.loading = false
        if (!res.errno) {
          this.bill = Object.assign({}, res.data.bill)
          this.orders = res.data.orders
        } else {
          this.$alert(res.message, {
            type: 'error',
            callback: () => this.$router.go(-1)
          })
        }
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    buildBill() {
      buildBillApi({
        period: this.bill.period
      }).then(res => {
        if (!res.errno) {
          this.$message.success(res.message)
          this.fetchData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    payBill() {
      //
    }
  }
}
</script>
